export default __webpack_public_path__ + "media/images/icon-phone-bf18e56e0a9e6eca8b949db81e8bfc4b.svg";